import React from "react";
import classes from "./HowToBecomePartner.module.scss";
import CustomImage from "../../CustomImage";
import Chevron from "../../UI/Icons/Chevron";

interface HowToBecomePartnerHighlightImg {
  url: string;
  alternativeText?: string;
}

interface HowToBecomePartnerCard {
  id: number;
  title: string;
  description: string;
  highlightImg?: HowToBecomePartnerHighlightImg;
}

interface HowToBecomePartnerData {
  id: number;
  title: string;
  description: string;
  card: HowToBecomePartnerCard[];
}

interface Props {
  howToBecomePartnerData?: HowToBecomePartnerData;
}

const HowToBecomePartner = ({ howToBecomePartnerData }: Props) => {
  if (!howToBecomePartnerData) return null;

  const { title, description, card: cards } = howToBecomePartnerData;

  return (
    <section className={classes["how-to-become-partner-container"]}>
      {title && <h2 className={classes.heading} dangerouslySetInnerHTML={{ __html: title }} />}
      {description && <div className={classes.subtext} dangerouslySetInnerHTML={{ __html: description }} />}

      <div className={classes["steps-row"]}>
        {cards?.length > 0 &&
          cards.map((card, index) => {
            const isLastCard = index === cards.length - 1;

            return (
              <React.Fragment key={card.id}>
                <div className={classes.card}>
                  <span className={classes["step-number"]}>{String(index + 1).padStart(2, "0")}</span>

                  <div className={`${classes["illustration-box"]}`}>
                    {card.highlightImg?.url && (
                      <CustomImage
                        src={card.highlightImg.url}
                        alt={card.highlightImg.alternativeText || card.title}
                        width={349}
                        height={208}
                        objectFit="contain"
                      />
                    )}
                  </div>

                  {card.title && <h3 className={classes["card-title"]}>{card.title}</h3>}
                  {card.description && <p className={classes["card-description"]}>{card.description}</p>}
                </div>

                {!isLastCard && (
                  <div className={classes.connector} aria-hidden="true">
                    <div className={classes["connector-icon-desktop"]}>
                      <Chevron width={16} height={16} color="#ffffff" />
                    </div>
                    <div className={classes["connector-icon-mobile"]}>
                      <Chevron width={16} height={16} color="#ffffff" />
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
      </div>
    </section>
  );
};

export default HowToBecomePartner;
